module.exports = __webpack_public_path__ + "img/20220624171559.dcfdd28e.png";